import Api from "../../../services/Api";

export function loginUser(credentials) {
  return Api.post(`/service/iqevse-csms/auth/v1/login`, credentials);
}
